const state = {
  activeUserDetails: {}
}

const mutations = {
  SET_ACTIVE_USER_DETAILS (state, payload) {
    state.activeUserDetails = Object.assign({}, payload)
  }
}

const actions = {
  setActiveUserDetails ({ commit }, payload) {
    commit('SET_ACTIVE_USER_DETAILS', payload)
  }
}

const getters = {
  getActiveUserDetails (state) {
    return state.activeUserDetails
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
